import { Chip, Tooltip } from "@mui/material"

export function CustomSkillIndicator({ rate }) {
    return (
        <Tooltip title={getTooltip(rate)}>
            <Chip
                label="Custom"
                size="small"
                color="warning"
                variant="outlined"
                sx={{ height: 20, fontSize: 11, fontWeight: 600 }}
                data-cy="custom-skill-indicator"
            />
        </Tooltip>
    )
}

function getTooltip(rate) {
    const numericRate = Number(rate)
    if (Number.isFinite(numericRate) && numericRate >= 0) {
        return `Custom skill rate ${numericRate.toFixed(2)} per hour`
    }
    return "Custom skill"
}
